import { z } from "zod";

export type Video = z.infer<typeof VideoSchema>;
export const VideoSchema = z.object({
  content: z.string(),
  type: z.string(),
});
